import axios from '@/axios'

const state = {
    postingTracker: [],
    postingTrackerCount: 0,
    postingTrackerFilter: {
        clients: {},
        batches: []
    },
    postingTrackerSummary: {},
};

const getters = {
    getPostingTracker: (state) => state.postingTracker,
    getPostingTrackerCount: (state) => state.postingTrackerCount,
    getPostingTrackerFilter: (state) => state.postingTrackerFilter,
    getPostingTrackerSummary: (state) => state.postingTrackerSummary,
};

const mutations = {
    setPostingTracker: (state, postingTracker) => (state.postingTracker = postingTracker),
    setPostingTrackerCount: (state, postingTrackerCount) => (state.postingTrackerCount = postingTrackerCount),
    setPostingTrackerFilter: (state, postingTrackerFilter) => (state.postingTrackerFilter = postingTrackerFilter),
    setPostingTrackerSummary: (state, postingTrackerSummary) => (state.postingTrackerSummary = postingTrackerSummary),
};

const actions = {
    async loadPostingTracker(context, data) {
        await axios().get(`/getPostingTracker`, {
            params: {
                is_tester: data.isTester || false,
                start: data.start,
                per_page: data.perPage,
                ...data.filter,
            }
        })
            .then(response => {
                context.commit('setPostingTracker', response.data.posting_tracker)
                context.commit('setPostingTrackerCount', response.data.posting_tracker_count)
                context.commit('setPostingTrackerSummary', response.data.posting_tracker_summary)
            })
    },
    async loadPostingTrackerFilter(context, data) {
        await axios().get(`/getPostingTrackerFilter`, {
            params: {
                client: data.client || null,
            }
        })
            .then(response => {
                context.commit('setPostingTrackerFilter', response.data)
            })
    },
    async postingTrackerResend(context, data) {

    },
    async postingTrackerSetStatus(context, data) {
        await axios().post(`/postingTrackerSetStatus`, {
            client: data.client || null,
            batch: data.batch || null,
            file: data.file || null,
            datetime: data.datetime || null,
        })
            .then(response => {
                //context.commit('setPostingTrackerFilter', response.data)
                // todo add message or smth?
            })
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
